// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__3sA8O","header":"styles_header__IiRky","back":"styles_back__2kDDW","title":"styles_title__OasOH","content":"styles_content__25KB6"};